import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function Toast({ message, onClose, type = "error", duration = 4000 }) {
    useEffect(() => {
        if (duration) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);

    // pick background color based on type
    const typeClasses = {
        success: "bg-green-500 text-white",
        error: "bg-red-500 text-white",
        info: "bg-blue-500 text-white",
        warning: "bg-yellow-400 text-yellow-900",
    };

    const classes = typeClasses[type] || "bg-red-500 text-white";

    return (
        <div className="fixed inset-0 flex items-center justify-center z-[9999] pointer-events-none">
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                className={`${classes} px-8 py-4 rounded-xl shadow-2xl text-center text-base font-bold pointer-events-auto`}
            >
                {message}
            </motion.div>
        </div>
    );
}
